import React from "react";

const CheckSimFooter = () => {
  return <div>CheckSimFooter</div>;
};

export default CheckSimFooter;
